import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ATP_SERVICE_URL } from 'src/app/injection-tokens';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AtpCallContext, AtpPortalRequest, AtpRequestItem, AtpResponseItem } from './atp-interfaces';

@Injectable({
  providedIn: 'root',
})
export class AtpService {
  constructor(
    @Inject(ATP_SERVICE_URL) readonly serviceURL: string,
    readonly http: HttpClient
  ) {}

  getAtpInfo(atpRequest: AtpPortalRequest): Observable<AtpResponseItem[]> {
    return this.http.post<AtpResponseItem[]>(this.serviceURL, atpRequest);
  }

  getSingleAtpInfo(context: AtpCallContext, atpRequestItem: AtpRequestItem): Observable<AtpResponseItem> {
    const atpRequest: AtpPortalRequest = {
      ...context,
      items: [atpRequestItem],
    };

    return this.getAtpInfo(atpRequest).pipe(
      map((response: AtpResponseItem[]) => {
        if (response.length === 0) {
          throw new Error('No response received for the provided request item.');
        }
        return response[0];
      })
    );
  }
}
